import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  SMALL_INPUT_MIN_WIDTH,
  SMALL_INPUT_WIDTH,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionD = () => {
  const translations = useTranslations();
  return (
    <Section
      title={translations.patientForms.transitionalCareForm.sectionD.title}
    >
      <SectionRow>
        <DatePickerWithLabel
          elementName="insurance_form_sent_date"
          inputSx={{
            minWidth: SMALL_INPUT_MIN_WIDTH,
            width: SMALL_INPUT_WIDTH,
          }}
          isBold
          label={
            translations.patientForms.transitionalCareForm.sectionD
              .dateFieldLabel
          }
          shouldDisableFuture
          wrapperSx={{ width: "100%" }}
        />
      </SectionRow>
    </Section>
  );
};
